exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reason-text[data-v-47707ec6]{color:red}span.is-invalid[data-v-47707ec6]{position:relative;left:2px;color:#dc3545}", ""]);

// exports
